<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link" class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom title="Agregar Línea" aria-label="Agregar Línea"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 260px;">
              <label class="filter-label">Buscar</label>
              <b-input-group>
                <b-form-input type="text" size="sm" placeholder="Ingrese su búsqueda" v-model="table.filter"></b-form-input>
                <b-input-group-append v-if="table.filter">
                  <b-button variant="outline-dark" size="sm" @click="table.filter = ''" v-b-tooltip.hover title="Limpiar búsqueda">
                    <AppIcon name="x" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card>
            <b-table class="mb-0 crud-lines-table app-table"
                    responsive
                    sticky-header="60vh"
                    :stacked="isMobileViewport ? 'md' : false"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :tbody-tr-class="rowClass"
                    @row-clicked="onRowClicked"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(observations)="data">
                  <span v-b-tooltip.hover title="Sub-líneas relacionadas">
                    <AppIcon name="diagram3" :font-scale="1.3" class="mr-1" :class="data.item.sublines.length ? 'text-success' : 'text-muted'" />
                    <b-badge :variant="data.item.sublines.length ? 'success' : 'secondary'" pill>{{data.item.sublines.length}}</b-badge>
                    <span class="ml-1 text-muted small">{{data.item.sublines.length == 1 ? 'sub-línea' : 'sub-líneas'}}</span>
                  </span>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-lines-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>
                    <b-dropdown-item @click="openSub(data.item)">
                      <AppIcon name="visibility" /> Visualizar
                    </b-dropdown-item>
                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="diagram3" title="No se encontraron líneas" description="Ajustá la búsqueda para ampliar el listado, o agregá una línea nueva." />
          </b-card>
        </b-col>
      </b-row>

      <b-sidebar
          id="sidebar-lines-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle de la Línea"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <div>{{itemSelected.name}}</div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrev"
                        v-b-tooltip.hover
                        title="Línea anterior"
                        @click="goPrev()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNext"
                        v-b-tooltip.hover
                        title="Línea siguiente"
                        @click="goNext()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="diagram3" /> Sub-Líneas
            </div>
            <b-button @click="addSub(itemSelected)" type="button" variant="outline-dark" size="sm" class="float-right mb-2" v-b-tooltip.hover title="Agregar Sub-Línea">
              <AppIcon name="add" /> Agregar
            </b-button>
            <b-table class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSub.items"
                      :fields="tableSub.fields"
                      v-if="tableSub.items.length">

              <template v-slot:cell(id)="data">
                <b>{{data.item.id}}</b>
              </template>

              <template v-slot:cell(observations)="data">
                <span v-b-tooltip.hover title="Productos relacionados">
                  <AppIcon name="box" :font-scale="1.3" class="mr-1" :class="data.item.count_products ? 'text-success' : 'text-muted'" />
                  <b-badge :variant="data.item.count_products ? 'success' : 'secondary'" pill>{{data.item.count_products || 0}}</b-badge>
                  <span class="ml-1 text-muted small">{{data.item.count_products == 1 ? 'producto' : 'productos'}}</span>
                </span>
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown no-caret size="sm" variant="outline-secondary" boundary="window">
                  <template #button-content>
                    <AppIcon name="more_vert" label="Opciones" class="mr-1" /> Opciones
                  </template>
                  <b-dropdown-item @click="editSub(data.item)">
                    <AppIcon name="edit" /> Editar
                  </b-dropdown-item>
                  <b-dropdown-item @click="removeSub(data.item)">
                    <AppIcon name="delete" class="text-danger" /> Eliminar
                  </b-dropdown-item>
                </b-dropdown>
              </template>

            </b-table>
            <EmptyState v-else icon="diagram3" title="Sin sub-líneas cargadas" description="Agregá las sub-líneas de esta línea." />
          </div>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="edit(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>

          <nav>
            <b-pagination class="mb-0"
                          size="sm"
                          pills
                          :total-rows="getRowCount(table.items)"
                          :per-page="table.perPage"
                          v-model="table.currentPage" />
          </nav>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="diagram3" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD SUB -->
      <b-modal v-model="modal.formSub.active"
              :key="modal.formSub._id"
              :id="modal.formSub._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formSub.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <FindObject type="productsLine"
                        @select-object="loadProductsLine($event)"
                        :valueID="crud.formSub.line_id"/>
          </b-col>
          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.formSub.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formSub.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveSub()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'
  import Param from '@/config/parameters'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PRODUCTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudItems',
          elements: {}
        },
        parameters: {
          haveLines: Helper.hasParametersAccess(Param.P7),
        },
        filtersOpen: false,
        isMobileViewport: false,
        detailDrawer: false,
        itemSelected: null,
        table : {
          items: [],
          fields: [],
          filter: null,
          isBusy: false,
          currentPage: 1,
          perPage: 50,
        },
        tableSub : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 50,
        },
        crud: {
          form: {
            id: 0,
            name: '',            
          }, 
          formSub: {
            id: 0,
            line_id: 0,
            line: null,
            name: '',            
          },                    
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          formSub: {
            active: false,
            title: ''
          },          
        },
        arr: {
          lines: [],          
        },                
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      if(!this.parameters.haveLines) {
        this.$router.push({ name: 'Error403' })
      }

      this.loadFieldTable()
      this.load()

      this.filtersOpen = StorageLocal.getValue('filters_open_crud_lines') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    computed: {
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrev() {
        return this.currentIndex > 0
      },
      canGoNext() {
        if(this.currentIndex < 0) {
          return false
        }
        return this.currentIndex < (this.table.items.length - 1)
      },
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_lines', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // Resalta la fila cuyo registro está abierto en el drawer.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (el kebab de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      openSub(item) {
        this.itemSelected = item
        this.tableSub.items = item.sublines || []
        this.detailDrawer = true
      },
      hideSub() {
        this.itemSelected = null
        this.detailDrawer = false
      },
      goPrev() {
        if(this.canGoPrev) this.openSub(this.table.items[this.currentIndex - 1])
      },
      goNext() {
        if(this.canGoNext) this.openSub(this.table.items[this.currentIndex + 1])
      },
      loadFieldTable() {
        // TABLE
        this.table.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + this.alignClass('text-center')})
        this.table.fields.push({key: 'name', label: 'Nombre', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'observations', label: 'Sub-Líneas', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle ' + this.alignClass('text-right')})

        // TABLE SUB (drawer, siempre vertical)
        this.tableSub.fields = []
        this.tableSub.fields.push({key: 'id', label: 'ID', sortable: true, class: 'align-middle'})
        this.tableSub.fields.push({key: 'name', label: 'Nombre', class: 'align-middle'})
        this.tableSub.fields.push({key: 'observations', label: 'Productos', class: 'align-middle'})
        this.tableSub.fields.push({key: 'f_action', label: 'Acción', class: 'align-middle'})
      },
      getRowCount (items) {
        return items.length
      },
      load() {
        this.table.isBusy = true

        var result = serviceAPI.obtenerLinea()

        result.then((response) => {
          var data = response.data
          this.table.items = data
          this.arr.lines = data

          if(this.itemSelected) {
            this.table.items.forEach(element => {
              if(element.id == this.itemSelected.id) {
                this.openSub(element)
              }
            })
          }

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = '' 

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Linea"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name   
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Linea"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Línea',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarLinea(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              if(this.itemSelected && this.itemSelected.id === item.id) {
                this.hideSub()
              }
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarLinea(this.crud.form);
        } else {
          var result = serviceAPI.agregarLinea(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },

      addSub(item) {
        this.crud.formSub.id = 0
        this.crud.formSub.line_id = item.id
        this.crud.formSub.name = '' 

        this.modal.formSub._id = Math.random().toString(36).slice(2, 8)
        this.modal.formSub.title = "Nuevo Sub-Linea"
        this.modal.formSub.active = true
      },
      editSub(item) {
        this.crud.formSub.id = item.id
        this.crud.formSub.line_id = item.line_id
        this.crud.formSub.name = item.name      
        
        this.modal.formSub._id = Math.random().toString(36).slice(2, 8)
        this.modal.formSub.title = "Editar Sub-Linea"
        this.modal.formSub.active = true
      },
      removeSub(item) {
        this.crud.formSub.id = item.id
        this.crud.formSub.name = item.name        

        this.confirmDialog('¿Desea borrar el item (' + this.crud.formSub.id + ') - '+ this.crud.formSub.name + '?', {
          title: 'Borrar Sub-Línea',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarSublinea(this.crud.formSub.id);

            result.then((response) => {      
              this.modal.formSub.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      saveSub() {
        let loader = this.$loading.show();
        if (this.crud.formSub.id) {
          var result = serviceAPI.editarSublinea(this.crud.formSub);
        } else {
          var result = serviceAPI.agregarSublinea(this.crud.formSub);
        }

        result.then((response) => {
          this.modal.formSub.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      loadProductsLine (object) {
        if(object){
          this.crud.formSub.line = object
          this.crud.formSub.line_id = object.id
        } else {
          this.crud.formSub.line = null
          this.crud.formSub.line_id = 0
        }
      },              
    }    
  }
</script>
<style>
  .btn.crud-lines-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-lines-action-toggle-labeled:hover,
  .btn.crud-lines-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-lines-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>